export interface User {
    id: string;
    email: string;
    fullName: string;
    apartmentNumber: string;
    role: string;
    isLockedOut: boolean;
    lockoutEnd: string | null;
}

export interface AuthResponse {
    token: string;
    email: string;
    fullName: string;
    role: string;
    expiresAt: string;
}

export interface LoginCredentials {
    email: string;
    password: string;
}

export interface RegisterData {
    email: string;
    password: string;
    fullName: string;
    apartmentNumber: string;
}

export interface Post {
    id: number;
    title: string;
    content: string;
    category: PostCategory;
    categoryName: string;
    authorId: string;
    authorName: string;
    createdAt: string;
    updatedAt: string | null;
    isPinned: boolean;
}

export interface Comment {
    id: number;
    content: string;
    postId: number;
    authorId: string;
    authorName: string;
    createdAt: string;
    updatedAt: string | null;
}

export interface CreateCommentData {
    content: string;
}

export enum PostCategory {
    General = 0,
    Maintenance = 1,
    Dugnad = 2,
    Outage = 3,
    Practical = 4
}

export interface CreatePostData {
    title: string;
    content: string;
    category: PostCategory;
    isPinned: boolean;
}

export interface CategoryInfo {
    value: number;
    name: string;
    displayName: string;
}

export interface Contact {
    id: number;
    contactPerson: string;
    company: string;
    role: string;
    phone?: string;
    email?: string;
}

export interface CreateContactData {
    contactPerson: string;
    company: string;
    role: string;
    phone?: string;
    email?: string;
}

export interface Document {
    id: number;
    title: string;
    description?: string;
    fileName: string;
    contentType: string;
    fileSize: number;
    fileSizeFormatted: string;
    category: DocumentCategory;
    categoryName: string;
    uploadedById: string;
    uploadedByName: string;
    uploadedAt: string;
}

export enum DocumentCategory {
    Husordensregler = 0,
    Vedtekter = 1,
    Arsmoter = 2,
    Referater = 3,
    FDV = 4,
    Brukerveiledninger = 5,
    Annet = 6
}

export interface UploadDocumentData {
    title: string;
    description?: string;
    category: DocumentCategory;
}

export interface DocumentCategoryInfo {
    value: number;
    name: string;
    displayName: string;
}
